import { lazy } from 'react';
import { Routes, SyncHook } from '../routeTypes';

const TvDashboardLayout = lazy(() =>
  import('react-components/tv-dashboard/TvDashboardLayout').then(module => ({
    default: module.TvDashboardLayout,
  }))
);

const TvDashboardPage = lazy(() =>
  import('react-components/tv-dashboard/TvDashboardPage').then(module => ({
    default: module.TvDashboardPage,
  }))
);

const useSyncHook: SyncHook = null;

/**
 * Pathless layout + index page for the TV wall. The `/tv-dashboard` URL prefix is registered in the app root
 * router before the consent `/:termKey` route.
 */
const routes: Routes = [
  {
    element: <TvDashboardLayout />,
    children: [{ index: true, element: <TvDashboardPage /> }],
  },
];

const useNavigationHooks = () => ({});

/** Route metadata for navigation hooks (public TV wall URL is wired in App.tsx). */
export const tvDashboardRouteConfig = {
  routes,
  useSyncHook,
  publicRoute: true,
  hideNavigationHeader: true,
  useNavigationHooks,
};
